export const isDownloadLink = (url: string) => url?.match(/^\/(wp-content|download)/i);